var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageNotes(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "writing 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5215 10.3125C16.5215 9.79472 16.1018 9.375 15.584 9.375H5.92773C5.40995 9.375 4.99023 9.79472 4.99023 10.3125C4.99023 10.8303 5.40995 11.25 5.92773 11.25H15.584C16.1018 11.25 16.5215 10.8303 16.5215 10.3125Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.92773 13.125C5.40995 13.125 4.99023 13.5447 4.99023 14.0625C4.99023 14.5803 5.40995 15 5.92773 15H11.7923C12.3101 15 12.7298 14.5803 12.7298 14.0625C12.7298 13.5447 12.3101 13.125 11.7923 13.125H5.92773Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.13054 22.125H4.99512C3.96124 22.125 3.12012 21.2839 3.12012 20.25V3.75C3.12012 2.71613 3.96124 1.875 4.99512 1.875H16.5212C17.555 1.875 18.3962 2.71613 18.3962 3.75V9.51562C18.3962 10.0334 18.8159 10.4531 19.3337 10.4531C19.8514 10.4531 20.2712 10.0334 20.2712 9.51562V3.75C20.2712 1.68225 18.5889 0 16.5212 0H4.99512C2.92737 0 1.24512 1.68225 1.24512 3.75V20.25C1.24512 22.3177 2.92737 24 4.99512 24H8.13054C8.64832 24 9.06804 23.5803 9.06804 23.0625C9.06804 22.5447 8.64832 22.125 8.13054 22.125Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.9321 13.5737C20.8355 12.4771 19.0513 12.477 17.9554 13.5729L12.8084 18.7085C12.6991 18.8176 12.6184 18.952 12.5735 19.0997L11.4526 22.7899C11.3532 23.1171 11.4398 23.4724 11.6786 23.7171C11.8575 23.9005 12.1005 24 12.3497 24C12.4331 24 12.5173 23.9888 12.5999 23.9659L16.3839 22.9177C16.5396 22.8746 16.6816 22.792 16.7959 22.6778L21.9322 17.5512C23.0288 16.4546 23.0288 14.6703 21.9321 13.5737ZM15.6458 21.1766L13.7421 21.7039L14.2992 19.8698L17.7722 16.4045L19.0982 17.7306L15.6458 21.1766ZM20.607 16.2248L20.4254 16.4061L19.0995 15.0802L19.2805 14.8996C19.6461 14.534 20.2408 14.534 20.6064 14.8996C20.9719 15.2651 20.9719 15.8598 20.607 16.2248Z",
    fill: "#51566D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.584 5.625H5.92773C5.40995 5.625 4.99023 6.04472 4.99023 6.5625C4.99023 7.08028 5.40995 7.5 5.92773 7.5H15.584C16.1018 7.5 16.5215 7.08028 16.5215 6.5625C16.5215 6.04472 16.1018 5.625 15.584 5.625Z",
    fill: "#51566D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageNotes);
export default __webpack_public_path__ + "static/media/manageNotes.397656b59a247e92ccff1a78c8c4a456.svg";
export { ForwardRef as ReactComponent };